module.exports = __webpack_public_path__ + "static/media/belice.71db59aa.png";